/*
 * cart-announcer.js - bridges cart events to the polite + alert live regions.
 *
 * Listens at document level:
 *   cart:item-added -> "{title} added to cart" (polite, debounced)
 *   cart:updated    -> "Cart updated, N item(s)" (polite, debounced)
 *   cart:error      -> "Error: {message}" (assertive)
 *
 * Messages read from window.LunchedCartAnnounce when present (locale-rendered in theme.liquid),
 * with English fallbacks for safety. Locale strings carry __TITLE__ / __COUNT__ / __MESSAGE__
 * placeholders that this module substitutes at runtime.
 */
(function () {
  if (window.__lunchedCartAnnouncerLoaded) return;
  window.__lunchedCartAnnouncerLoaded = true;

  function ready() {
    var status = document.getElementById('cart-live-status');
    var alert = document.getElementById('cart-live-alert');
    if (!status || !alert) return setTimeout(ready, 30);
    init(status, alert);
  }

  function init(status, alert) {
    var debounce = null;
    var labels = window.LunchedCartAnnounce || {};

    function announcePolite(text) {
      clearTimeout(debounce);
      status.textContent = '';
      debounce = setTimeout(function () { status.textContent = text; }, 50);
    }
    function announceAlert(text) {
      alert.textContent = '';
      setTimeout(function () { alert.textContent = text; }, 50);
    }

    document.addEventListener('cart:item-added', function (e) {
      var item = e && e.detail && e.detail.item;
      var title = (item && (item.product_title || item.title)) || '';
      if (!title) return;
      var tmpl = labels.added || '__TITLE__ added to cart';
      announcePolite(tmpl.replace('__TITLE__', title));
    });

    document.addEventListener('cart:updated', function (e) {
      var cart = e && e.detail && e.detail.cart;
      if (!cart || typeof cart.item_count !== 'number') return;
      var n = cart.item_count;
      var tmpl = (n === 1 ? labels.updated_one : labels.updated_other) || 'Cart updated, __COUNT__ items';
      announcePolite(tmpl.replace('__COUNT__', String(n)));
    });

    document.addEventListener('cart:error', function (e) {
      var detail = (e && e.detail) || {};
      var message = detail.message || 'Cart error';
      var tmpl = labels.error || 'Error: __MESSAGE__';
      announceAlert(tmpl.replace('__MESSAGE__', message));
      // For inventory cap errors specifically, also surface a visible toast.
      // Other error codes (discount_invalid, bundle_active, etc.) are rendered
      // inline next to the relevant input by component-cart-drawer / -main.
      if (detail.code === 'inventory_capped') showInventoryToast(message);
    });
  }

  function showInventoryToast(text) {
    var existing = document.getElementById('cart-inventory-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.id = 'cart-inventory-toast';
    toast.className = 'cart-toast cart-toast--inventory';
    toast.setAttribute('role', 'status');
    toast.textContent = text;
    document.body.appendChild(toast);
    // Two-frame defer to let the browser apply the initial style before the
    // .is-visible transition target. requestAnimationFrame is deterministic
    // here where setTimeout(..., 0) sometimes batches with the append in some
    // browsers and skips the transition.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    });
    setTimeout(function () { toast.classList.remove('is-visible'); }, 3500);
    setTimeout(function () { if (toast.parentNode) toast.remove(); }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
